import { EsTextoAlfaNumerico } from './FuncionesTexto.js';
import * as Filtros from '../constantes/Filtros.js';
import * as FiltrosURL from '../constantes/FiltrosURL.js';
import * as Funciones from './FuncionesFiltrosBase.js';

const parseIdParam = (value) => {
  const id = Number(value);
  return Number.isNaN(id) ? value : id;
};

export const ObjetoFiltrosVacio = () => {
  return {
    nombre: Funciones.FiltroFalse(null),
    pais: Funciones.FiltroFalse(null),
    provincia: Funciones.FiltroFalse(null),
    localidad: Funciones.FiltroFalse(null),
    buscar: false,
  };
};

export const ArmarBodyFiltros = (filtros) => {
  return {
    nombreLike: filtros.nombre.estado && filtros.nombre.valor !== '' ? filtros.nombre.valor : '',
    idPais: filtros.pais.estado && filtros.pais.valor ? filtros.pais.valor.id : null,
    idProvincia:
      filtros.provincia.estado && filtros.provincia.valor ? filtros.provincia.valor.id : null,
    idLocalidad:
      filtros.localidad.estado && filtros.localidad.valor ? filtros.localidad.valor.id : null,
  };
};

export const ArmarFiltroParametros = (nuevoFiltro, parametros) => {
  if (parametros && parametros.length > 0) {
    for (const parameter of parametros) {
      switch (parameter[0]) {
        case FiltrosURL.PAIS: {
          nuevoFiltro = {
            ...nuevoFiltro,
            pais: Funciones.FiltroTrue({ id: parseIdParam(parameter[1]) }),
            buscar: true,
          };
          break;
        }
        case FiltrosURL.PROVINCIA: {
          nuevoFiltro = {
            ...nuevoFiltro,
            provincia: Funciones.FiltroTrue({ id: parseIdParam(parameter[1]) }),
            buscar: true,
          };
          break;
        }
        case FiltrosURL.LOCALIDAD: {
          nuevoFiltro = {
            ...nuevoFiltro,
            localidad: Funciones.FiltroTrue({ id: parseIdParam(parameter[1]) }),
            buscar: true,
          };
          break;
        }
        default:
      }
    }
  }
  return nuevoFiltro;
};

export const BotonReducer = (state, action) => {
  switch (action.value) {
    case Filtros.Club.NOMBRE: {
      return {
        ...state,
        nombre: Funciones.InvertirFiltro(state.nombre),
      };
    }
    case Filtros.Club.PAIS: {
      return state.pais.estado
        ? {
            ...state,
            pais: Funciones.FiltroFalse(state.pais),
            provincia: Funciones.FiltroFalse(state.pais),
            localidad: Funciones.FiltroFalse(state.localidad),
          }
        : { ...state, pais: Funciones.FiltroTrue(state.pais) };
    }
    case Filtros.Club.PROVINCIA: {
      return {
        ...state,
        provincia: Funciones.InvertirFiltro(state.provincia),
      };
    }
    case Filtros.Club.LOCALIDAD: {
      return {
        ...state,
        localidad: Funciones.InvertirFiltro(state.localidad),
      };
    }
    default: {
      return state;
    }
  }
};

export const FiltrosReducer = (state, action) => {
  switch (action.type) {
    case Filtros.Club.NOMBRE: {
      return {
        ...state,
        nombre: Funciones.FiltroValor(state.nombre, action.value),
      };
    }
    case Filtros.Club.PAIS: {
      return {
        ...state,
        pais: Funciones.FiltroValor(state.pais, action.value),
        provincia: Funciones.FiltroValor(state.provincia, ''),
        localidad: Funciones.FiltroValor(state.localidad, ''),
      };
    }
    case Filtros.Club.PROVINCIA: {
      return {
        ...state,
        provincia: Funciones.FiltroValor(state.provincia, action.value),
        localidad: Funciones.FiltroValor(state.localidad, ''),
      };
    }
    case Filtros.Club.LOCALIDAD: {
      return {
        ...state,
        localidad: Funciones.FiltroValor(state.localidad, action.value),
      };
    }
    default: {
      return ObjetoFiltrosVacio();
    }
  }
};

export const ValidarFiltros = (filtros) => {
  let error = '';
  if (
    !(filtros.nombre.estado && filtros.nombre.valor !== '') &&
    !(filtros.pais.estado && filtros.pais.valor !== '')
  ) {
    error = 'Seleccione al menos un filtro de búsqueda';
  } else if (filtros.nombre.estado && (!filtros.nombre.valor || filtros.nombre.valor.length < 3)) {
    error = 'El nombre a buscar debe tener al menos 3 caracteres';
  } else if (
    filtros.nombre.estado &&
    (!filtros.nombre.valor || !EsTextoAlfaNumerico(filtros.nombre.valor))
  ) {
    error = 'El nombre a buscar no es válido';
  }
  return error;
};
